<template lang="pug">
.cadastro-page-actions
  button.cadastro-page-actions__btn.cadastro-page-actions__btn--outline(
    type="button"
    @click="$emit('cancelar')"
  ) Cancelar

  .cadastro-page-actions__right
    button.cadastro-page-actions__btn.cadastro-page-actions__btn--outline(
      v-if="mostrarVoltar"
      type="button"
      @click="$emit('voltar')"
    )
      img.cadastro-page-actions__icon-left(
        src="@/assets/icons/cadastro/arrow-left.svg"
        alt=""
      )
      | Voltar

    button.cadastro-page-actions__btn.cadastro-page-actions__btn--primary(
      v-if="mostrarContinuar"
      type="button"
      @click="$emit('continuar')"
    )
      | Continuar
      img.cadastro-page-actions__icon-right(
        src="@/assets/icons/cadastro/arrow-right.svg"
        alt=""
      )

    button.cadastro-page-actions__btn.cadastro-page-actions__btn--primary(
      v-if="mostrarCadastrar"
      type="button"
      @click="$emit('cadastrar')"
    )
      | Cadastrar
      img.cadastro-page-actions__icon-right(
        src="@/assets/icons/cadastro/arrow-right.svg"
        alt=""
      )
</template>

<script>
export default {
  name: 'CadastroPageActions',
  props: {
    mostrarVoltar: {
      type: Boolean,
      default: false
    },
    mostrarContinuar: {
      type: Boolean,
      default: false
    },
    mostrarCadastrar: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-page-actions {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  width: 100%;
}

.cadastro-page-actions__right {
  align-items: center;
  display: flex;
  gap: 16px;
}

.cadastro-page-actions__btn {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
  height: 40px;
  justify-content: center;
  line-height: 1.43;
  padding: 0 16px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &--outline {
    background: #ffffff;
    border: 1px solid #eaeaea;
    color: #141414;
  }

  &--primary {
    background: #1e174e;
    border: 1px solid transparent;
    color: #ffffff;
  }
}

.cadastro-page-actions__icon-left,
.cadastro-page-actions__icon-right {
  height: 16px;
  width: 16px;
}
</style>
